app.service('salesBox', function (
	store,
	productCardConfig,
	modalShops,
	modalDelivery,
	statusDelivery,
	availabilityNotification
) {
	let $self, config;

	function init(props) {
		$self = props.$el.find('#sales-box');
		config = productCardConfig.getData();

		setEvents();
	}

	function setEvents() {
		$self
			.on('click', '.js-product-shop-delivery', handleShopDeliveryClick)
			.on('click', '.js-product-shop-delivery-only-available', handleShopDeliveryOnlyAvailableClick)
			.on('click', '.js-product-home-delivery', handleHomeDeliveryClick)
			.on('click', '.js-product-status-delivery', handleProductStatusDeliveryClick)

		$('body').on('click', '.js-same-day-shops-notice', function() {
			handleHomeDeliveryClick();
		});

		availabilityNotification.validateAvailabilityNotificationForm();
	}

	function handleShopDeliveryClick() {
		modalShops.showModal(config.id, {
			calledFrom: 'delivery'
		});
		modalShops.logEvent(config.id);
		UA.pageInteraction('CTA', 'Sprawdź dostępność w sklepach');
	}

	function handleShopDeliveryOnlyAvailableClick() {
		modalShops.showModal(config.id, {
			calledFrom: 'delivery',
			onlyAvailableToOrder: true
		});
		UA.pageInteraction('CTA', $.trim($(this).text()));
	}

	function handleHomeDeliveryClick() {
		modalDelivery.showModal({
			productId: config.id,
			outletCategoryId: store.data.outletCategoryId
		});
		UA.pageInteraction('CTA', 'Sprawdź termin dostawy');
	}

	function handleProductStatusDeliveryClick() {
		statusDelivery.load(config.productAvailabilityStatusCode, config.id);
	}

	return {
		init
	};
});